<template>
  <div class="hello">

    <agile :arrows="false" :speed="1000"
           :timing="'linear'" :fade="true"
           :autoplay="true" :pauseOnHover="true">
      <div class="slide slide--1"></div>
      <div class="slide slide--2"></div>
      <div class="slide slide--3"></div>
    </agile>

  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/colors.scss";
.hello{
  width: 50%;
  height: 100%;
}



</style>
